module.exports = __webpack_public_path__ + "img/258.06f01f1d.jpg";